import { GQLOrderItemFragment, GQLOrderItemPrintSideType } from '@theprintbar/graphql';
import { invariant } from '../../utils';

export const orderedOrderItemSides: GQLOrderItemPrintSideType[] = [
	GQLOrderItemPrintSideType.Front,
	GQLOrderItemPrintSideType.Back,
	GQLOrderItemPrintSideType.Left,
	GQLOrderItemPrintSideType.Right,
	GQLOrderItemPrintSideType.Label,
];

export function getSortedOrderItemDecorations(orderItem: Pick<GQLOrderItemFragment, 'prints'>) {
	invariant(orderItem.prints, 'Order item must have prints');
	//Return the merch sides in the order of the sortOrder array
	return orderItem.prints.sort((a, b) => {
		invariant(a.side && b.side, 'Sides must have a side');
		return orderedOrderItemSides.indexOf(a.side) - orderedOrderItemSides.indexOf(b.side);
	});
}
